import { WhiteContainer } from "@components";
import { FC } from "react";
import { Box, CircularProgress } from "@mui/material";

const Loading = () => {
  return (
    <Box
      sx={{
        zIndex: 1000,
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
      }}
    >
      <div
        className={
          "h-full min-h-[300px] flex items-center justify-center gap-4"
        }
      >
        <CircularProgress sx={{ zIndex: 1000 }} />
      </div>
    </Box>
  );
};
export default Loading;
